import React, { useEffect } from 'react';
import { X } from 'lucide-react';

const sizeMap = { sm: 'max-w-md', md: 'max-w-lg', lg: 'max-w-2xl', xl: 'max-w-4xl' };

export default function Modal({ open, onClose, title, subtitle, children, size = 'md', footer }) {
  useEffect(() => {
    if (open) document.body.style.overflow = 'hidden';
    else document.body.style.overflow = '';
    return () => { document.body.style.overflow = ''; };
  }, [open]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[9990] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/40 backdrop-blur-sm" onClick={onClose} />
      <div className={`relative bg-white rounded-2xl shadow-2xl w-full ${sizeMap[size] || sizeMap.md} flex flex-col max-h-[90vh] animate-in fade-in slide-in-from-bottom-4 duration-200`}>
        <div className="flex items-start justify-between p-6 border-b border-[#E5E3DE]">
          <div>
            <h2 className="text-lg font-semibold text-[#1A1915]" style={{ fontFamily: 'Manrope, sans-serif' }}>{title}</h2>
            {subtitle && <p className="mt-0.5 text-sm text-[#5C5A54]">{subtitle}</p>}
          </div>
          <button onClick={onClose} className="p-1.5 rounded-lg hover:bg-[#F4F3F0] text-[#9B9893] hover:text-[#1A1915] transition-colors ml-4">
            <X size={16} />
          </button>
        </div>
        <div className="overflow-y-auto flex-1 p-6">{children}</div>
        {footer && <div className="p-6 border-t border-[#E5E3DE] bg-[#FAFAF8] rounded-b-2xl">{footer}</div>}
      </div>
    </div>
  );
}

export function ConfirmModal({ open, onClose, onConfirm, title, message, confirmLabel = 'Confirm', danger = false }) {
  return (
    <Modal open={open} onClose={onClose} title={title} size="sm">
      <p className="text-sm text-gray-600 mb-6">{message}</p>
      <div className="flex gap-3 justify-end">
        <button onClick={onClose} className="px-4 py-2 text-sm font-medium text-gray-600 border border-gray-200 rounded-lg hover:bg-gray-50">
          Cancel
        </button>
        <button
          onClick={() => { onConfirm(); onClose(); }}
          className={`px-4 py-2 text-sm font-medium text-white rounded-lg ${danger ? 'bg-red-600 hover:bg-red-700' : 'bg-[#1b3a6b] hover:bg-[#152d55]'}`}
        >
          {confirmLabel}
        </button>
      </div>
    </Modal>
  );
}

export { Modal };
